import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAllStrings } from '../features/language/languageSlice';
import React, { useState } from 'react';
import FullAccessModal from '../features/user/FullAccessModal';

const PurchaseButton = () => {
    const strings = useSelector(selectAllStrings);
    const [showAccessModal, setShowAccessModal] = useState(false);

    const buyClicked = event => {
        event.preventDefault();
        setShowAccessModal(true);
    };

    return <React.Fragment>
        <div id="registration">
            <a href="#" onClick={buyClicked}>
                {strings.buy_card_link}
            </a>
        </div>
        {showAccessModal ? <FullAccessModal onClose={() => setShowAccessModal(false)}/> : null}
    </React.Fragment>
            ;
};

export default PurchaseButton;